import {
  AfterViewInit,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import {
  close as closeColorPicker,
  coloris,
  init as initColorPicker,
} from '@melloware/coloris';

@Component({
  selector: 'brand-color-field',
  templateUrl: './brand-color-field.component.html',
})
export class BrandColorFieldComponent implements AfterViewInit {
  private destroyRef = inject(DestroyRef);

  readonly fieldId = input.required<string>();
  readonly label = input.required<string>();
  readonly description = input.required<string>();
  readonly color = input('');

  readonly colorChange = output<string>();

  private trigger =
    viewChild.required<ElementRef<HTMLButtonElement>>('trigger');

  readonly accessibleName = computed(
    () => `${this.label()}, ${this.color() || 'no color set'}`,
  );

  ngAfterViewInit(): void {
    initColorPicker();
    // Coloris reads and writes the trigger's `value` and returns focus to it
    // on close. `wrap: false` keeps it from wrapping the button in its own
    // swatch field; children ignore pointer events so the button is always the
    // click target Coloris binds to.
    coloris({
      el: this.trigger().nativeElement,
      wrap: false,
      themeMode: 'auto',
      format: 'rgb',
      formatToggle: false,
      alpha: true,
      focusInput: true,
    });

    const picker = document.getElementById('clr-picker');
    const closeOnEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        closeColorPicker();
      }
    };
    picker?.addEventListener('keydown', closeOnEnter);
    this.destroyRef.onDestroy(() =>
      picker?.removeEventListener('keydown', closeOnEnter),
    );
  }

  onColorInput(): void {
    this.colorChange.emit(this.trigger().nativeElement.value);
  }
}
